import { render, staticRenderFns } from "./blogger_match.vue?vue&type=template&id=75ac1c39&scoped=true"
import script from "./blogger_match.vue?vue&type=script&lang=ts"
export * from "./blogger_match.vue?vue&type=script&lang=ts"
import style0 from "./blogger_match.vue?vue&type=style&index=0&id=75ac1c39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac1c39",
  null
  
)

export default component.exports